import { getNumberOfSpotsLeft } from '../../../tournaments/registration/Wizard/components/DivisionCard/utils/capacity';
export const getAtCapacityDisabledReason = (subProgramLabel) => `You have selected the maximum number of teams allowed for this ${subProgramLabel}.`;
export const isDivisionAtCapacity = (division, teamSelections) => {
    const numberOfSpotsLeft = getNumberOfSpotsLeft(division);
    return (numberOfSpotsLeft !== undefined &&
        teamSelections.filter(({ teamId }) => teamId.length).length >=
            numberOfSpotsLeft);
};
export const disableTeamForAtCapacity = (teamOption, selections, atCapacityDisabledReason) => {
    return Object.assign(Object.assign({}, teamOption), { disabled: !teamOption.checkboxState ||
            !!selections.find((teamSelection) => teamSelection.teamId === teamOption.value), disabledReason: teamOption.disabled
            ? teamOption.disabledReason
            : atCapacityDisabledReason });
};
export const enableTeamForAtCapacity = (teamOption, atCapacityDisabledReason) => {
    return Object.assign(Object.assign({}, teamOption), { disabled: teamOption.disabledReason === atCapacityDisabledReason
            ? false
            : teamOption.disabled, disabledReason: teamOption.disabledReason === atCapacityDisabledReason
            ? undefined
            : teamOption.disabledReason });
};
